<template>
  <section class="logoWrapper">
    <div class="logoLeft">
      <img src="./logo_left.png" alt="logo1">
    </div>
    <div class="logoRight">
      <img src="./logo_right.png" alt="logo2">
    </div>
  </section>
</template>

<script>
export default {
  name: 'Logo'
}
</script>

<style lang="less" scoped>
.logoWrapper {
  position: absolute;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  height: 1.25rem /* 20/16 */;
  width: 100%;
  padding: 0 1.25rem /* 20/16 */;
  margin-top: 1.25rem /* 20/16 */;
  top: 0;
  .logoLeft {
    width: 3.4375rem /* 55/16 */;
    height: .9375rem /* 15/16 */;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .logoRight {
    width: 7.5rem /* 120/16 */;
    height: 1.125rem /* 18/16 */;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
